import type { ApiAddress } from '#/api/types/ApiAddress';
import type { ApiRemoteOptionsWithFormData } from '#/api/types/ApiRemoteOptions';

type Args = {
  remoteOptions?: Partial<ApiRemoteOptionsWithFormData>;
  org: { address: ApiAddress };
};

export function getAddressForRemoteOptions({
  remoteOptions,
  org,
}: Args): ApiAddress | undefined {
  const hasRemotePart =
    remoteOptions?.locationType === 'REMOTE' ||
    remoteOptions?.locationType === 'HYBRID';

  const isNotInASpecificCity =
    remoteOptions?.remoteZone === 'STATE' ||
    remoteOptions?.remoteZone === 'COUNTRY' ||
    remoteOptions?.remoteZone === 'WORLD';

  if (hasRemotePart && isNotInASpecificCity && remoteOptions?.useOrgAddress) {
    const orgLocationIsCityOnly = !org.address.line1;

    return {
      ...org.address,
      locationHidden: orgLocationIsCityOnly,
    };
  }
}
